import { useAuthState, useRedirect } from "react-admin"

// the whole purpose of this page is to check authorization
export const RootPage = () => {
  const { isLoading, authenticated } = useAuthState(undefined, true);
  const redirect = useRedirect();
  
  if(!isLoading && authenticated) {
    redirect('/events')
  }

  return null;
}
